export enum ActionTypes {
  SET_ACTIVE_MODE = 'editProject/SET_ACTIVE_MODE',
  SET_ACTIVE_LINE = 'editProject/SET_ACTIVE_LINE',
}
